import * as React from "react"

export const AvantVerticalDivider = () => (
    <div style={{display: "flex", flexDirection: "column"}}>
        <div
            style={{
                boxSizing: "border-box",
                flexGrow: 1,
                width: 0,
                outline: "1px solid #E8E8E8"
            }}
        />
    </div>
)
